<script>
export default {
	name: 'IconSvgRtf',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.3989 4.104C12.9343 4.10356 12.4887 3.92237 12.1602 3.60023C11.8316 3.27809 11.6468 2.8413 11.6463 2.38572V1.54872e-07H3.81568C3.51524 -0.000109302 3.21772 0.0578014 2.94012 0.170444C2.66253 0.283086 2.41028 0.44825 2.1978 0.656487C1.98532 0.864725 1.81677 1.11196 1.70177 1.38408C1.58677 1.65619 1.52759 1.94785 1.52759 2.2424V15.7602C1.52759 16.0547 1.58677 16.3464 1.70177 16.6185C1.81677 16.8906 1.98532 17.1379 2.1978 17.3461C2.41028 17.5543 2.66253 17.7195 2.94012 17.8321C3.21772 17.9448 3.51524 18.0027 3.81568 18.0026H13.2162C13.8228 18.0026 14.4046 17.7663 14.8335 17.3458C15.2625 16.9253 15.5034 16.3549 15.5034 15.7602V4.104H13.3989Z"
				:fill="color" />
			<path
				d="M15.5035 4.104H13.399C12.9343 4.10355 12.4888 3.92237 12.1602 3.60023C11.8316 3.27809 11.6468 2.8413 11.6464 2.38572V0L15.5035 4.104Z"
				fill="#4F89D5" />
			<path
				d="M12.628 6.97717H3.85304C3.76873 6.97717 3.68788 6.94433 3.62827 6.88588C3.56865 6.82744 3.53516 6.74817 3.53516 6.66551C3.53505 6.62452 3.54319 6.5839 3.55911 6.54599C3.57504 6.50808 3.59844 6.47362 3.62797 6.4446C3.6575 6.41557 3.69257 6.39254 3.73119 6.37683C3.76981 6.36112 3.81122 6.35303 3.85304 6.35303H12.628C12.7125 6.35303 12.7936 6.38595 12.8534 6.44456C12.9131 6.50316 12.9467 6.58264 12.9467 6.66551C12.9465 6.74825 12.9128 6.82752 12.8531 6.88594C12.7933 6.94437 12.7124 6.97717 12.628 6.97717Z"
				fill="#4F89D5" />
			<path
				d="M12.628 8.8413H3.85304C3.76873 8.8413 3.68788 8.80846 3.62827 8.75002C3.56865 8.69157 3.53516 8.61231 3.53516 8.52965C3.53505 8.48865 3.54319 8.44804 3.55911 8.41013C3.57504 8.37222 3.59844 8.33776 3.62797 8.30873C3.6575 8.2797 3.69257 8.25668 3.73119 8.24097C3.76981 8.22525 3.81122 8.21716 3.85304 8.21716H12.628C12.7125 8.21716 12.7936 8.25007 12.8534 8.30867C12.9131 8.36727 12.9467 8.44677 12.9467 8.52965C12.9465 8.61238 12.9128 8.69164 12.8531 8.75006C12.7933 8.80848 12.7124 8.8413 12.628 8.8413Z"
				fill="#4F89D5" />
			<path
				d="M12.628 10.7054H3.85304C3.81122 10.7054 3.76981 10.6974 3.73119 10.6816C3.69257 10.6659 3.6575 10.6429 3.62797 10.6139C3.59844 10.5848 3.57504 10.5504 3.55911 10.5125C3.54319 10.4746 3.53505 10.4339 3.53516 10.393C3.53516 10.3103 3.56865 10.231 3.62827 10.1726C3.68788 10.1141 3.76873 10.0813 3.85304 10.0813H12.628C12.7124 10.0813 12.7933 10.1141 12.8531 10.1725C12.9128 10.2309 12.9465 10.3102 12.9467 10.393C12.9467 10.4758 12.9131 10.5553 12.8534 10.6139C12.7936 10.6725 12.7125 10.7054 12.628 10.7054Z"
				fill="#4F89D5" />
			<path
				d="M9.16528 12.5695H3.85304C3.81122 12.5695 3.76981 12.5614 3.73119 12.5456C3.69257 12.5299 3.6575 12.5069 3.62797 12.4779C3.59844 12.4488 3.57504 12.4144 3.55911 12.3765C3.54319 12.3386 3.53505 12.298 3.53516 12.257C3.53516 12.1743 3.56865 12.095 3.62827 12.0366C3.68788 11.9781 3.76873 11.9453 3.85304 11.9453H9.16528C9.24958 11.9453 9.33043 11.9781 9.39005 12.0366C9.44966 12.095 9.48316 12.1743 9.48316 12.257C9.48327 12.298 9.47513 12.3386 9.4592 12.3765C9.44328 12.4144 9.41988 12.4488 9.39035 12.4779C9.36082 12.5069 9.32575 12.5299 9.28712 12.5456C9.2485 12.5614 9.20709 12.5695 9.16528 12.5695Z"
				fill="#4F89D5" />
			<path
				d="M17.1626 14.2169H6.53471C5.78082 14.2169 5.16968 14.8161 5.16968 15.5552V18.6617C5.16968 19.4008 5.78082 20 6.53471 20H17.1626C17.9165 20 18.5276 19.4008 18.5276 18.6617V15.5552C18.5276 14.8161 17.9165 14.2169 17.1626 14.2169Z"
				fill="#4F89D5" />
			<path d="M13.3735 15.8557V16.3374H12.6935V18.3616H12.0835V16.3374H11.4102V15.8557H13.3735Z"
				  fill="#F3F3F6" />
			<path d="M15.4246 15.8557V16.3374H14.3971V16.8865H15.1913V17.3474H14.3971V18.3616H13.7913V15.8557H15.4246Z"
				  fill="#F3F3F6" />
			<path
				d="M10.4705 18.3615L9.91722 17.4149H9.77612V18.3615H9.1582V15.8558H10.2139C10.3896 15.8511 10.5641 15.8861 10.7238 15.9583C10.8549 16.0194 10.9644 16.1174 11.0383 16.2399C11.1095 16.3651 11.1455 16.5066 11.1429 16.6499C11.1478 16.8174 11.0935 16.9814 10.989 17.1141C10.8752 17.2488 10.7177 17.3411 10.5428 17.3757L11.1505 18.3615H10.4705ZM9.77612 17.0007H10.1595C10.2574 17.0079 10.3544 16.9781 10.4306 16.9174C10.4608 16.8861 10.4839 16.8489 10.4986 16.8083C10.5132 16.7677 10.519 16.7245 10.5156 16.6816C10.5184 16.6389 10.5123 16.5962 10.4977 16.5559C10.4831 16.5156 10.4603 16.4787 10.4306 16.4474C10.3554 16.386 10.2586 16.3561 10.1612 16.3641H9.77783L9.77612 17.0007Z"
				fill="#F3F3F6" />
			<path d="M8.91259 17.7557V18.3615H8.27258V17.7557H8.91259Z" fill="#F3F3F6" />
		</svg>

	</div>
</template>

<style scoped>

</style>